import { render, staticRenderFns } from "./EditAcceptedType.vue?vue&type=template&id=6a1b29c1&scoped=true&"
import script from "./EditAcceptedType.vue?vue&type=script&lang=js&"
export * from "./EditAcceptedType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b29c1",
  null
  
)

export default component.exports